<template>
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.AdminLogin.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.AdminLogin.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.AdminLogin.msg3') }}</div>
      </div>
      <div class="layer__body mg-sm">
        <div style="position: relative; width: 100%; height: 80px; margin-bottom: var(--txt-pd20); z-index: 10">
          <ul class="optionList">
            <li class="optionItem" @click="clickOption()" v-for="cashierInfo in cashierList" :key="cashierInfo">
              {{ cashierInfo.CASHIER_ID }}
            </li>
          </ul>
          <div class="input-area" style="z-index: 10; position: absolute; top: 0px; left: 0px">
            <label for="">{{ $t('Admin.CashierLogin.msg3') }}</label>
          </div>
          <div class="selectBox">
            <button class="label bluefont" value="">Employee1</button>
          </div>
          <!-- <button class="btn-eye masking"></button> -->
        </div>
        <div class="input-area input-area2">
          <label for="">{{ $t('Modal.AdminLogin.msg5') }}</label>
          <input type="password" id="pwpwd" class="input-pw" v-model="password" :placeholder="$t('Admin.CashierLogin.msg6')" />
          <input type="text" id="pwtext" class="input-pw" v-model="password" :placeholder="$t('Admin.CashierLogin.msg6')" style="display: none" />
          <button class="btn-eye masking" @mouseup="showPwd()"></button>
          <!-- <button class="btn-eye masking"></button> -->
        </div>
        <div class="flex-row">
          <div class="lyr-left"><img src="@/assets/images/user/artwork_popup_staff_3d.gif" alt="" class="img-size" /></div>
          <div class="lyr-right">
            <div class="keypad--admin">
              <div class="keypad">
                <button @mouseup="setPwd(1)">1</button>
                <button @mouseup="setPwd(2)">2</button>
                <button @mouseup="setPwd(3)">3</button>
                <button @mouseup="setPwd(4)">4</button>
                <button @mouseup="setPwd(5)">5</button>
                <button @mouseup="setPwd(6)">6</button>
                <button @mouseup="setPwd(7)">7</button>
                <button @mouseup="setPwd(8)">8</button>
                <button @mouseup="setPwd(9)">9</button>
                <button @mouseup="setPwd(10)" class="delete">{{ $t('Modal.AdminLogin.msg6') }}</button>
                <button @mouseup="setPwd(0)">0</button>
                <button @mouseup="setPwd(-1)" class="btn-back">DEL</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="closeAdminLogin()">{{ $t('Modal.AdminLogin.msg7') }}</button>
        <button class="btn" :class="[password.length < 4 ? 'btn--disabled' : 'btn--submit']" @mouseup="login()">
          {{ $t('Modal.AdminLogin.msg8') }}
        </button>
        <!-- <button class="btn btn--submit">ログイン</button> -->
      </div>
    </div>
  </div>
  <AlertVue :text="this.text" :message="this.message" v-if="alertYn" @setYes="setYes" />
</template>
<script>
import axios from 'axios';
import alertVue from '@/components/modal/alert/AlertSuccess.vue';
export default {
  name: 'adminLogin',
  data() {
    return {
      password: '',
      cashierList: [],
      text: '',
      message: '',
      alertYn: false,
      showYn: false,
    };
  },
  mounted() {},
  props: {},
  components: {
    AlertVue: alertVue,
  },
  methods: {
    showPwd() {
      var pwpwd = document.getElementById('pwpwd');
      var pwtext = document.getElementById('pwtext');
      var btneye = document.querySelector('.btn-eye');
      if (this.showYn) {
        pwpwd.style.display = 'none';
        pwtext.style.display = 'block';
        btneye.classList.remove('masking');
      } else {
        pwpwd.style.display = 'block';
        pwtext.style.display = 'none';
        btneye.classList.add('masking');
      }
      this.showYn = !this.showYn;
    },
    closeAdminLogin() {
      this.$emit('closeAdminLogin');
    },
    setYes() {
      this.text = '';
      this.message = '';
      this.alertYn = false;
    },
    login() {
      if (this.password.length < 4) return false;
      this.$emit('setBasketOrder');
    },
    setPwd(num) {
      if (num == 10) this.password = '';
      else if (num < 0) this.password = this.password.slice(0, -1);
      else this.password += num + '';
      console.log(this.password);
    },
    clickOption() {
      const label = document.querySelector('.label');
      label.classList.contains('bluefont') ? null : label.classList.add('bluefont');
      label.innerHTML = event.target.textContent;
      label.value = event.target.textContent;
      this.id = event.target.textContent;

      this.closebox();
    },
    selectbox() {
      /* 화살표 함수 */
      const optionList = document.querySelector('.optionList');
      optionList.classList.contains('active') ? optionList.classList.remove('active') : optionList.classList.add('active');
    },
    closebox() {
      document.querySelector('.optionList').classList.remove('active');
    },
  },
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style src='@/assets/css/user/pages/keypad.css' scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .flex-row {
    zoom: 0.8;
  }

  .lyr-right {
    margin: auto !important;
  }

  .ft-point {
    font-size: 1.2em !important;
  }
}

.selectBox * {
  box-sizing: border-box;
}
.selectBox {
  position: relative;
  background: url('@/assets/images/admin/btn_arrow_open.png') calc(100% - 10px) center no-repeat;
  background-size: 80px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.selectBox.active {
  background: url('@/assets/images/admin/btn_arrow_close.png') calc(100% - 20px) center no-repeat;
  background-size: 80px;
}

.selectBox:after {
  content: '';
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 35px;
  /* background: lightcoral; */
}

.selectBox .label {
  display: flex;
  align-items: center;
  width: inherit;
  height: inherit;
  border: 0 none;
  outline: 0 none;
  justify-content: center;
  background: transparent;
  cursor: pointer;
  color: #afafaf;
  font-size: 1.2em;
}

.optionList {
  position: absolute;
  top: 20px;
  left: 0px;
  width: 100%;
  background: #e1e1e1;
  color: #000;
  list-style-type: none;
  overflow: auto;
  max-height: 0;
  transition: 0.1s ease-in;
  padding-left: 0px;
}

.optionList.active {
  max-height: 340px;
  border-radius: 20px;
  padding-top: 60px;
}

.optionItem {
  height: 80px;
  font-size: 40px;
  text-align: center;
  line-height: 4vh;
}

.optionItem:hover {
  background: #5457d7;
}

.optionItem:last-child {
  border-bottom: 0 none;
}

.optionList::-webkit-scrollbar {
  display: none;
}

.bluefont {
  color: #5457d7 !important;
  font-weight: bold;
}
</style>
